[
    {
        "id": "opacityRange",
        "title": "Countries opacity",
        "description": "Change the opacity of the countries on the map.",
        "type": "slider",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "value": 0.5,
        "property": "countriesOpacity"
    },
    {
        "id": "stationsRadius",
        "title": "Stations size",
        "description": "Change the size of the stations on the map.",
        "type": "slider",
        "min": 1,
        "max": 10,
        "step": 0.5,
        "value": 3.5,
        "property": "stationsSize"
    },
    {
        "id": "markerSymbol",
        "title": "Stations symbol",
        "description": "Change the symbol of the stations on the map.",
        "type": "select",
        "options": [
            {
                "label": "Circle",
                "value": "circle"
            },
            {
                "label": "Square",
                "value": "square"
            }
        ],
        "value": "circle",
        "property": "stationsSymbol"
    },
    {
        "id": "markerOutline",
        "title": "Stations outline",
        "description": "Change the outline of the stations on the map.",
        "type": "select",
        "options": [
            {
                "label": "true",
                "value": "true"
            },
            {
                "label": "false",
                "value": "false"
            }
        ],
        "value": "true",
        "property": "stationsOutline"
    },
    {
        "id": "mapBackground",
        "title": "Map background",
        "description": "Change the background color of the map.",
        "type": "select",
        "options": [
            {
                "label": "Blank",
                "value": "blank"
            },
            {
                "label": "OSM",
                "value": "OSM"
            }
        ],
        "value": "blank",
        "property": "mapBackground"
    }
]